import template from './sync-to-github-modal.html';

class SyncToGithubModalController {
  commitMessage: string;
  private $close: any;

  constructor() {}

  submit() {
    this.$close({ $commitMessage: this.commitMessage });
  }
}

export const syncToGithubModalDirective = function (Modal) {
  return {
    restrict: 'A',
    scope: {
      commitMessage: '<',
      onSync: '&',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click', (event) => {
        const modal = Modal.open(
          {
            commitMessage: $scope.commitMessage,
          },
          {
            controller: SyncToGithubModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );

        modal.result
          .then((opts) => {
            $scope.onSync({ $commitMessage: opts.$commitMessage });
          })
          .catch(function () {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click'));
    },
  };
};

syncToGithubModalDirective.$inject = ['ModalService'];
